import ErrorBox, { ErrorBoxProps } from '@components/ErrorBox';
import { useRouteError } from '@router';

export type ErrorRouteProps = Omit<ErrorBoxProps, 'error'> & {};

/**
 * Route error handler for error
 * @returns
 */
export const ErrorRoute: React.FC<ErrorRouteProps> = () => {
  const error: any = useRouteError();

  return <ErrorBox error={error} />;
};

export default ErrorRoute;
